import { Injectable, Inject } from '@angular/core';
import { AuthToken } from '../models/auth-token';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthTokenService {
    private tokenKey = "SmithsNews";
    
    private token: AuthToken = null;
 
    constructor(private cookieService: CookieService) {
        this.tokenKey = this.tokenKey;
        if (this.cookieService.get(this.tokenKey) != "") {
            const tokenJson = this.cookieService.get(this.tokenKey);
            //console.log("Constructor of Auth Token:" + tokenJson);
            this.token = JSON.parse(tokenJson);
        }
    }
    getToken(): AuthToken {
        //console.log("Start getToken");
        //console.log("token in getToken:" + JSON.stringify(this.token));
        // if (this.token == null && this.cookieService.get(this.tokenKey) != "") {
        //     const tokenJson = this.cookieService.get(this.tokenKey);
        //     this.token = JSON.parse(tokenJson);
        //     console.log("if Condition getToken");
        // }
        var tokenJson = this.cookieService.get(this.tokenKey);
        if(tokenJson != null && tokenJson != "")
        {
            //console.log("Token:" + tokenJson);
            var temptoken = this.token = JSON.parse(tokenJson);
            //console.log("end getToken");
            //console.log("token at the End in getToken:" + JSON.stringify(this.token));
            return temptoken;
        }
        else
        {
            return null;
        }
    }
    setToken(token: AuthToken): void {
        //console.log("Start setToken");
        //console.log("start Token:" + JSON.stringify(token))
        if (typeof (Storage) !== "undefined") {
            this.cookieService.set(this.tokenKey, JSON.stringify(token), 1);
            //console.log("if Condition setToken");
            this.token = token;
        }
        //console.log("End SetToken:" + JSON.stringify(this.token))
        //console.log("end getToken");
    }

   
    
    hasToken(): boolean {
        return this.token ? true : false;
    }
    clearToken(): void {
        this.cookieService.delete(this.tokenKey);
        this.token = null;
        
     }
}